import axios from 'axios'
import { bankGroupUrl, getHeader } from '../config'

const state = {
  bankGroupList: []
}

const mutations = {
  SET_BANK_GROUP_LIST (state, obj) {
    state.bankGroupList = obj
  }
}

const actions = {
  getBankGroupList: ({ commit }) => {
    axios.get(bankGroupUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_BANK_GROUP_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
